// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".student-list-meta{flex-direction:row-reverse}", "",{"version":3,"sources":["webpack://app/pages/Students/style.scss"],"names":[],"mappings":"AAMA,mBACE,0BAAA","sourcesContent":["// Style for Students container\r\n\r\n/* Global Variables */\r\n// @import \"scss/global/variables\";\r\n\r\n// fix the problem of alignement of the student list\r\n.student-list-meta {\r\n  flex-direction: row-reverse;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
